/*******************************************************************************
 * @ngdoc    object
 * @module   makeDeposit
 * @name     csm.books.MakeDeposit.Data.type:DepositInfo
 * @constructor
 * @param {object=} info  Item info read from database.
 * @description
 * Bank deposit info.
 *******************************************************************************/
/* @ngInject */ export function runDepositInfoData(Data) {
  Data.DepositInfo = function (info) {
    var rv = Object.assign(
      Object.create(Data.DepositInfo.prototype),
      info || {}
    );
    rv.items = rv.items.map(function (r) {
      return r.isQuickItem
        ? new Data.QuickDepositItem(r)
        : new Data.DepositReceiptItem(r);
    });
    return rv;
  };

  Data.DepositInfo.prototype = {
    bankAccountID: NaN, // Bank Account ID
    adjustAccountID: 0, // Adjustment Account ID.
    totalNumberChecks: 0, // Number of checks deposited
    totalAmountChecks: 0, // Amount of checks deposited
    totalAmountCash: 0, // Amount of cash deposited.
    totalDepositChecks: 0, // Total deposit amount from checks.
    totalDepositCash: 0, // Total deposit amount from cash.
    totalAmount: 0, // Total deposit amount.
    handwritten: false, // Handwritten Flag
    printed: false, // Printed Flag
    cleared: false, // Cleared Flag
    source: 0, // Source indicator.
    sourceID: null, // Source ID.

    items: [],

    get canDrop() {
      /**
       * Checks to see if the Deposit Date (entryDate of dbo.LedgerEntries) falls under the
       * most recent bank reconciliation date for this organization.
       */
      const fallsUnderRecentBankRecon =
        this.lastReconciledDate && this.entryDate
          ? this.lastReconciledDate > this.entryDate
          : false;
      /**
       * In order to drop, 3 criteria has to be met.
       * 1. The Deposit Record has to exist (Deposit ID is also the same as dbo.LedgerEntries ID).
       * 2. The Deposit has NOT been cleared yet.
       * 3. The Deposit date does NOT fall under the last Bank Reconciliation date.
       *
       * For more information please reference the business rule:
       * (https://graystep.atlassian.net/wiki/spaces/BR/pages/1745551361/Deposits+-+Dropping)
       */
      return this.id > 0 && !this.cleared && !fallsUnderRecentBankRecon;
    },
    get canReview() {
      return this.source == 0;
    },
    get isNew() {
      return (this.id || 0) == 0;
    },
    get receiptIds() {
      return this.items
        .filter(function (r) {
          return !r.isQuickItem;
        })
        .map(function (r) {
          return r.id;
        });
    }
  };
};
